import { createAction } from 'typesafe-actions';
import { TourStep } from '../types/schema.type';

export const setStep = createAction('setStep', (action) => {
  return (selectedStep: TourStep) => action({ selectedStep });
});
